import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { isEachWayOffered } from 'src/domains/sportsbook/utils/isEachWayOffered';
import { EachWayTermsType } from './EachWayDetails';

export const getEachWayTerms = (market: MarketModel): EachWayTermsType | undefined => {
    if (!isEachWayOffered(market)) {
        return undefined;
    }

    return market.eachWay?.terms[0];
};
